import { connectConsumer } from "../modules/redux-consumer";
import { KioskState } from "../kiosk";
import * as ActionTypes from "../actions/actionTypes";
import { call } from "../actions/sipActions";
import { loadServices } from "../actions/serviceActions";
import parseQueryParams from "../modules/parse-query-params";

const kioskReadyStateConsumer = ({
  router,
  audio,
  video,
  text,
  callableNumbers,
  restrictNumbers,
  dispatch,
}) => {
  const queryParams = parseQueryParams(router.location.search.substr(1));
  if (restrictNumbers) {
    if (callableNumbers.length === 0) {
      dispatch(loadServices());
    } else {
      if (callableNumbers.some(e => e.sipaddress === queryParams.to)) {
        dispatch(
          call(
            queryParams.to,
            audio,
            video,
            text,
            queryParams.ivr,
            queryParams.ref
          )
        );
      } else {
        dispatch({ type: ActionTypes.CALL_TO_UNREGISTERED });
      }
    }
  } else {
    dispatch(
      call(queryParams.to, audio, video, text, queryParams.ivr, queryParams.ref)
    );
  }
};

const mapStateToProps = state => {
  return {
    router: state.router,
    audio: state.config.audio,
    video: state.config.video,
    text: state.config.mode.safetext,
    restrictNumbers: state.config.mode.restrict,
    callableNumbers: state.service.services,
  };
};

const filter = state =>
  state.router.location.pathname === "/oneclickcall" &&
  state.kiosk.state === KioskState.ready &&
  (!state.config.mode.restrict || !state.service.loading);
export default connectConsumer(
  mapStateToProps,
  null,
  null,
  filter
)(kioskReadyStateConsumer);

export const isRunningInIFrame = window => {
  if (!window) return false;
  try {
    return !!(window.self !== window.top);
  } catch (e) {
    //
    // Same Origin Policy can block access to window.top
    // Also,
    return false;
  }
};

export const kioskStateToExternalMessage = callState => {
  switch (callState) {
    case KioskState.calling:
      return {
        status: 200,
        message: "calling",
      };
    case KioskState.acceptedRemote:
      return {
        status: 201,
        message: "accepted remote",
      };
    case KioskState.callCompleted:
      return {
        status: 202,
        message: "call completed",
      };
    case KioskState.rejectedRemote:
    case KioskState.busy:
      return {
        status: 486,
        message: "call rejected remote",
      };
    case KioskState.terminatedLocal:
      return {
        status: 487,
        message: "call terminated local",
      };
    case KioskState.terminatedRemote:
      return {
        status: 488,
        message: "call terminated remote",
      };
    case KioskState.unknownNumber:
      return {
        status: 404,
        message: "unknown number",
      };
    case KioskState.unregisteredNumber:
      return {
        status: 405,
        message: "unregistered number",
      };
    case KioskState.wrongUsernamePassword:
      return {
        status: 400,
        message: "wrong username or password",
      };
    case KioskState.tokenInvalid:
      return {
        status: 400,
        message: "invalid token",
      };
    case KioskState.tokenExpired:
      return {
        status: 400,
        message: "expired token",
      };
    default:
      return {
        status: -1,
        message: "unknown status",
      };
  }
};

export const kioskStateToExternalMessage2 = callState => {
  switch (callState) {
    case KioskState.callCompleted:
      return "202";
    case KioskState.rejectedRemote:
      return "486";
    case KioskState.terminatedLocal:
      return "487";
    case KioskState.terminatedRemote:
      return "487";
    default:
      return "-1";
  }
};

export const kioskCallStateConsumerInternal = ({
  callState,
  window,
  document,
}) => {
  if (!isRunningInIFrame(window)) return;

  //const origin = document.referrer;

  const message = kioskStateToExternalMessage(callState);
  window.parent.postMessage(message, "*");
};

export const kioskCallStateConsumer = connectConsumer(
  state => ({ callState: state.kiosk.state, window, document }),
  null,
  null,
  state =>
    state.router.location.pathname === "/oneclickcall" &&
    (state.kiosk.state === KioskState.calling ||
      state.kiosk.state === KioskState.acceptedRemote ||
      state.kiosk.state === KioskState.callCompleted ||
      state.kiosk.state === KioskState.rejectedRemote ||
      state.kiosk.state === KioskState.terminatedLocal ||
      state.kiosk.state === KioskState.terminatedRemote ||
      state.kiosk.state === KioskState.unknownNumber ||
      state.kiosk.state === KioskState.unregisteredNumber ||
      state.kiosk.state === KioskState.wrongUsernamePassword ||
      state.kiosk.state === KioskState.tokenInvalid ||
      state.kiosk.state === KioskState.tokenExpired)
)(kioskCallStateConsumerInternal);






// WEBPACK FOOTER //
// ./src/consumers/kioskStateConsumer.js